export const LANGUAGE_CHANGE_STATE = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    INPROGRESS: 'INPROGRESS'
}
